export const pregnancyQueryKeys = {
  all: ['pregnancy'],
  details: () => [...pregnancyQueryKeys.all, 'detail'],
  detail: (id) => [...pregnancyQueryKeys.details(), id],
  pagination: (page, filters = {}) => {
    // Create a consistent, serializable representation of filters
    const filterKey = Object.entries(filters)
      .filter(([, value]) => value !== undefined && value !== '')
      .map(([key, value]) => `${key}:${value}`)
      .sort()
      .join('|');

    return [
      ...pregnancyQueryKeys.all,
      'pagination',
      page.toString(),
      filterKey,
    ];
  },
  infinite: () => [...pregnancyQueryKeys.all, 'infinite'],
};
